const SAML_SERVICE = process.env.NEXT_PUBLIC_SAML_SERVICE

export const shouldRedirectToSamlLogin = (emailAddress: string): boolean => {
	return typeof SAML_SERVICE !== 'undefined' && emailAddress !== ''
}

export const redirectToSamlLogin = (emailAddress: string) => {
	if (!shouldRedirectToSamlLogin(emailAddress)) {
		return
	}

	// SAML_SERVICE is guaranteed to be defined here
	window.location.assign(SAML_SERVICE!)
}
